import React from 'react'
import cn from 'classnames'

import './styles.scss'

const bc = 'error-block-component'

const ErrorBlock = ({ children, organizationDisabled }) => (
  <div
    className={cn(bc, {
      [`${bc}__organization-disabled`]: organizationDisabled,
    })}
  >
    {children}
  </div>
)

export default ErrorBlock
